import Logo from "../shared/Logo"
import Navbar from "./Navbar"
import { Button } from "../ui/button"
import { useNavigate } from "react-router-dom"
import useAuthStore from "../../store/authStore"
import ProfileHeader from "./ProfileHeader"

export default function Header () {
  const { user} = useAuthStore()
  const navigate = useNavigate()
  return (
    <header className="flex flex-row justify-between px-8 items-center bg-white w-full top-0 fixed shadow-sm z-10">
      <Logo />
      <div className="flex items-center gap-8">
        <Navbar  />
        {user ?
        <ProfileHeader />
        :
        <Button onClick={() => navigate('/login')}>
          Login | Register
        </Button>
        }
      </div>
    </header>
  )
}
